export default function Footer() {
  const scrollToSection = (id: string) => {
    const element = document.getElementById(id);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <footer className="bg-[#1B4332] text-white">
      {/* Main Footer Content */}
      <div className="px-6 lg:px-20 py-16">
        <div className="max-w-7xl mx-auto grid md:grid-cols-2 lg:grid-cols-4 gap-12">
          {/* Brand Column */}
          <div>
            <div className="flex items-center gap-3 mb-4">
              <img 
                src="https://public.readdy.ai/ai/img_res/b0dc4a27-3dc1-4704-a5fd-c629c8ae3a8e.png" 
                alt="Kebabish Kebab" 
                className="h-10 w-auto brightness-0 invert"
              />
              <span className="text-xl font-bold">Kebabish Kebab</span>
            </div>
            <p className="text-gray-300 leading-relaxed text-sm">
              El mejor kebab de Pozuelo de Alarcón. Ingredientes frescos, sabor auténtico y servicio rápido desde 2015.
            </p>
          </div>

          {/* Newsletter Column */}
          <div>
            <h4 className="text-xs font-bold text-gray-400 mb-4 tracking-wider">NEWSLETTER</h4>
            <p className="text-sm text-gray-300 mb-4">Recibe nuestras ofertas especiales</p>
            <div className="flex items-center border-b border-gray-500 pb-2">
              <input
                type="email"
                placeholder="Tu email"
                className="bg-transparent flex-1 text-white placeholder-gray-400 outline-none text-sm"
              />
              <button className="text-white hover:text-[#E63946] transition-colors cursor-pointer whitespace-nowrap">
                <i className="ri-arrow-right-line text-xl"></i>
              </button>
            </div>
            <p className="text-xs text-gray-400 mt-2">
              Al suscribirte aceptas nuestra <span className="underline cursor-pointer">política de privacidad</span>
            </p>
          </div>

          {/* Menu Column */}
          <div>
            <h4 className="text-xs font-bold text-gray-400 mb-4 tracking-wider">MENÚ</h4>
            <ul className="space-y-3">
              <li>
                <button onClick={() => scrollToSection('menu')} className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer">
                  Carta
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('ofertas')} className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer">
                  Ofertas
                </button>
              </li>
              <li>
                <button onClick={() => scrollToSection('delivery')} className="text-gray-300 hover:text-white transition-colors text-sm cursor-pointer">
                  Delivery
                </button>
              </li>
            </ul>
          </div>

          {/* Social Column */}
          <div>
            <h4 className="text-xs font-bold text-gray-400 mb-4 tracking-wider">SÍGUENOS</h4>
            <ul className="space-y-3">
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm flex items-center gap-2 cursor-pointer whitespace-nowrap">
                  <i className="ri-instagram-line"></i> Instagram
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm flex items-center gap-2 cursor-pointer whitespace-nowrap">
                  <i className="ri-facebook-line"></i> Facebook
                </a>
              </li>
              <li>
                <a href="#" className="text-gray-300 hover:text-white transition-colors text-sm flex items-center gap-2 cursor-pointer whitespace-nowrap">
                  <i className="ri-map-pin-line"></i> Google Maps
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>

      {/* Large Typography Section */}
      <div className="px-6 lg:px-20 py-12 border-t border-gray-600">
        <div className="max-w-7xl mx-auto">
          <div className="text-[#F5F3EF]/20 font-bold text-6xl lg:text-8xl tracking-tight text-center">
            KEBABISH
          </div>
        </div>
      </div>

      {/* Bottom Bar */}
      <div className="px-6 lg:px-20 py-6 border-t border-gray-600">
        <div className="max-w-7xl mx-auto flex flex-col md:flex-row items-center justify-between gap-4 text-sm text-gray-400">
          <p>© 2024 Kebabish Kebab. Todos los derechos reservados.</p>
          <a 
            href="https://readdy.ai/?ref=logo" 
            target="_blank" 
            rel="noopener noreferrer"
            className="hover:text-white transition-colors cursor-pointer whitespace-nowrap"
          >
            Website Builder
          </a>
        </div>
      </div>
    </footer>
  );
}
